import { Box, Table, TableBody, TableHead, Typography } from "@mui/material"
import Specification from "./Specification";
import VehicleRow from "./Vehicle/VehicleRow";
import VehicleHeader from "./Vehicle/VehicleHeader";
import { SearchVehicleData } from "../types";

interface SearchVehicleInfoProps {
    searchVehicle: SearchVehicleData | null;
}

/** Информация о транспортном средстве */
export const SearchVehicleInfo = ({ searchVehicle }: SearchVehicleInfoProps) => {
    return searchVehicle && searchVehicle.headers.length
        ? <Box>
            <Typography
                variant="h6"
                style={{ paddingLeft: 16, }}
            >
                {searchVehicle.vehicle.brand} {searchVehicle.vehicle.name}
            </Typography>
            <div style={{ marginBottom: 15, padding: 8, }}>
                <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <Table>
                        <TableHead>
                            <VehicleHeader
                                vehicleAttributes={searchVehicle.headers}
                            />
                        </TableHead>
                        <TableBody>
                            <VehicleRow
                                vehicleAttributes={searchVehicle.headers}
                                vehicle={searchVehicle.vehicle}
                            />
                        </TableBody>
                    </Table>
                </Box>
                <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                    <Specification searchVehicle={searchVehicle} isMobile />
                </Box>
            </div>
        </Box>
        : null;
};